/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { accountsCountAccountsApiV2LedgersLedgerCanisterIdAccountsCountGet } from "../../funcs/accountsCountAccountsApiV2LedgersLedgerCanisterIdAccountsCountGet.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request:
    operations
      .CountAccountsApiV2LedgersLedgerCanisterIdAccountsCountGetRequest$inboundSchema,
};

export const tool$accountsCountAccountsApiV2LedgersLedgerCanisterIdAccountsCountGet:
  ToolDefinition<typeof args> = {
    name: "accounts-count-v2",
    description: `Original tool name: accounts-count-accounts-api-v2-ledgers-ledger-canister-id-accounts-count-get

Get the total number of accounts that meet the criteria`,
    args,
    tool: async (client, args, ctx) => {
      const [result, apiCall] =
        await accountsCountAccountsApiV2LedgersLedgerCanisterIdAccountsCountGet(
          client,
          args.request,
          { fetchOptions: { signal: ctx.signal } },
        ).$inspect();

      if (!result.ok) {
        return {
          content: [{ type: "text", text: result.error.message }],
          isError: true,
        };
      }

      const value = result.value;

      return formatResult(value, apiCall);
    },
  };